// Wrapper de react-toastify que limita los toasts EN PANTALLA a un máximo (MAX_TOASTS).
// Cuando aparece uno nuevo y ya hay MAX en pantalla, se cierra el MÁS VIEJO (no se encola),
// así el modo automático de la carrera —que dispara un toast por jornada— no apila media
// docena de avisos. Expone la misma API que usábamos de react-toastify (toast.info/.error/
// .success/.warning y toast.dismiss), por lo que los call sites no cambian.
import { toast as rtToast } from 'react-toastify';

const MAX_TOASTS = 2;

// Ids de los toasts actualmente vivos, del más viejo al más nuevo.
const active = [];

function track(method, content, opts = {}) {
    const userOnClose = opts.onClose;
    let id;
    id = rtToast[method](content, {
        ...opts,
        onClose: (...args) => {
            const i = active.indexOf(id);
            if (i >= 0) active.splice(i, 1);
            if (userOnClose) userOnClose(...args);
        },
    });
    active.push(id);
    // Si nos pasamos del máximo, cerramos los más viejos hasta volver al límite.
    while (active.length > MAX_TOASTS) {
        const oldest = active.shift();
        rtToast.dismiss(oldest);
    }
    return id;
}

export const toast = {
    info:    (content, opts) => track('info', content, opts),
    error:   (content, opts) => track('error', content, opts),
    success: (content, opts) => track('success', content, opts),
    warning: (content, opts) => track('warning', content, opts),
    warn:    (content, opts) => track('warning', content, opts),
    dismiss: (id) => rtToast.dismiss(id),
};

export default toast;
